import { unlockTherapistConstant } from './constant';

const {
  GET_UNLOCK_THERAPIST_REQUEST,
  GET_UNLOCK_THERAPIST_LOADING,
  GET_LOCK_DAILY_SESSION_NOTES_REQUEST,
  POST_UNLOCK_THERAPIST_RESET,
  GET_LOCK_DAILY_SESSION_NOTES_RESET,
  POST_UNLOCK_THERAPIST_REQUEST,
} = unlockTherapistConstant;

export const getUnlockTherapistAction = (payload: any) => {
  return {
    type: GET_UNLOCK_THERAPIST_REQUEST,
    payload,
  };
};

export const getLockDailySessionNoteAction = (payload: any) => {
  return {
    type: GET_LOCK_DAILY_SESSION_NOTES_REQUEST,
    payload,
  };
};

export const resetLockDailySessionNoteAction = () => {
  return {
    type: GET_LOCK_DAILY_SESSION_NOTES_RESET,
  };
};

export const updateUnlockTherapistAction = (payload: any) => {
  return {
    type: POST_UNLOCK_THERAPIST_REQUEST,
    payload,
  };
};

export const resetUpdateTherapistUnlock = () => {
  return {
    type: POST_UNLOCK_THERAPIST_RESET,
  };
};
